import { toast } from "sonner";
import { promptInstall, useInstallMethod } from "@/lib/installPrompt";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { DeviceMobile, DownloadSimple } from "@phosphor-icons/react";

const STEPS = {
  ios: "In Safari, tap Share, then Add to Home Screen.",
  android: "Open your browser's menu (⋮) and tap Install app or Add to Home screen.",
};

/**
 * Offers to install FinFlo as an app that opens outside the browser. Hidden
 * once it is installed, and on browsers that cannot install it at all.
 */
export default function InstallAppCard() {
  const method = useInstallMethod();
  if (!method || method === "installed") return null;

  const install = async () => {
    if (await promptInstall()) toast.success("FinFlo is installed");
  };

  return (
    <Card className="bg-card border-border p-5 rounded-lg" data-testid="install-app-card">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <DeviceMobile size={18} className="mt-0.5 shrink-0" />
          <div>
            <h3 className="font-heading font-bold tracking-tight">Install the app</h3>
            <p className="text-sm text-muted-foreground mt-1">
              {STEPS[method] ?? "Open FinFlo from your home screen or desktop, in its own window."}
            </p>
          </div>
        </div>
        {method === "prompt" && (
          <Button
            size="sm"
            className="bg-income text-black hover:bg-income/90 gap-1.5 sm:shrink-0"
            onClick={install}
            data-testid="install-app-btn"
          >
            <DownloadSimple size={15} weight="bold" /> Install
          </Button>
        )}
      </div>
    </Card>
  );
}
